// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__iuAPo","left":"InfoRow_left__5M1o9"};